import { MemberAvatar, getMemberRoleLabel } from '../equipeUi';
import { getMemberTodayPresence } from '../../../utils/equipePresencesToday';

const STATUS_PILL = {
  emerald: 'bg-emerald-100 text-emerald-800',
  amber: 'bg-amber-100 text-amber-900',
  gray: 'bg-gray-100 text-gray-600',
  rose: 'bg-rose-100 text-rose-800',
  slate: 'bg-slate-100 text-slate-700',
};

export default function PresencesMemberList({
  members,
  selectedId,
  onSelect,
  horairesByInstructeur,
  absencesByInstructeur,
  dateExceptionsByInstructeur = {},
}) {
  const sorted = [...(members || [])].sort((a, b) => {
    const na = `${a.nom || ''}${a.prenom || ''}`.toLowerCase();
    const nb = `${b.nom || ''}${b.prenom || ''}`.toLowerCase();
    return na.localeCompare(nb, 'fr');
  });

  return (
    <div className="flex h-full flex-col rounded-2xl border border-gray-100 bg-white shadow-sm">
      <div className="border-b border-gray-100 px-4 py-3">
        <h2 className="text-sm font-bold text-gray-900">Membres</h2>
        <p className="mt-0.5 text-xs text-gray-500">{sorted.length} personne{sorted.length > 1 ? 's' : ''}</p>
      </div>
      <div className="min-h-0 flex-1 space-y-1.5 overflow-y-auto p-2">
        {sorted.length === 0 ? (
          <p className="px-2 py-6 text-center text-sm text-gray-500">Aucun membre.</p>
        ) : (
          sorted.map((m) => {
            const config = m.instructeurId ? horairesByInstructeur[m.instructeurId] : null;
            const absences = m.instructeurId ? absencesByInstructeur[m.instructeurId] || [] : [];
            const dateExceptions = m.instructeurId
              ? dateExceptionsByInstructeur[m.instructeurId] || null
              : null;
            const today = getMemberTodayPresence(m, config, absences, dateExceptions);
            const prestCount = m.prestationCount ?? 0;
            const selected = selectedId === m.id;

            return (
              <button
                key={m.id}
                type="button"
                onClick={() => onSelect?.(m.id)}
                className={`flex w-full items-center gap-2.5 rounded-xl border px-2.5 py-2.5 text-left transition ${
                  selected
                    ? 'border-violet-200 bg-violet-50/60 ring-1 ring-violet-100'
                    : 'border-transparent bg-white hover:border-gray-100 hover:bg-gray-50/80'
                }`}
              >
                <MemberAvatar member={m} size="sm" />
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-semibold text-gray-900">
                    {m.prenom} {m.nom}
                  </p>
                  <p className="truncate text-[11px] text-gray-500">{getMemberRoleLabel(m)}</p>
                  {m.isIntervenant && prestCount > 0 ? (
                    <p className="mt-0.5 text-[10px] text-gray-400">
                      {prestCount} prestation{prestCount > 1 ? 's' : ''} attribuée{prestCount > 1 ? 's' : ''}
                    </p>
                  ) : null}
                </div>
                <span
                  className={`shrink-0 rounded-full px-2 py-0.5 text-[10px] font-semibold ${STATUS_PILL[today.tone] || STATUS_PILL.gray}`}
                >
                  {today.label}
                </span>
              </button>
            );
          })
        )}
      </div>
    </div>
  );
}
